import { inject } from '@angular/core'
import { CanActivateFn, Route, Router, Routes } from '@angular/router'
import { authGuard } from '@app/core/guards/auth.guard'
import { createPermissionGuard } from '@app/core/guards/permission.guard'
import { PERMISSIONS } from '@app/core/constants/permissions.constants'
import { PermissionService } from '@core/services/permission-service/permission-service'

/** Queue is readable with view; review implies view so Finance users with only review still land. */
export const financeQueueGuard: CanActivateFn = async () => {
    const permissionService = inject(PermissionService)
    const router = inject(Router)
    await permissionService.getPermissionsBitwise()
    const canOpen =
        permissionService.canAccessPermissionOrImplicitFullAccess(
            PERMISSIONS.VIEW_PAYMENT_CLAIMS,
        ) ||
        permissionService.canAccessPermissionOrImplicitFullAccess(PERMISSIONS.REVIEW_PAYMENT_CLAIMS)
    if (canOpen) {
        return true
    }
    router.navigate(['/'])
    return false
}

/** Finance (NAV-12643). Opening a claim needs review (NAV-12636). */
export const financePaymentDetailRoute: Route = {
    path: 'payments/:paymentId',
    loadComponent: () =>
        import('./payments/payment-detail/payment-detail-page.component').then(
            (m) => m.PaymentDetailPageComponent,
        ),
    canActivate: [createPermissionGuard(PERMISSIONS.REVIEW_PAYMENT_CLAIMS)],
    data: { title: 'Payment review' },
}

export const financeRoutes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'payments' },
    financePaymentDetailRoute,
    {
        path: 'payments',
        loadComponent: () =>
            import('./payments/finance-payments-page.component').then(
                (m) => m.FinancePaymentsPageComponent,
            ),
        data: { title: 'Payments' },
    },
]

/** The app route for /finance; kept here so its guard can be tested without the whole route table. */
export const financeAppRoute: Route = {
    path: 'finance',
    loadChildren: () => import('./finance.routes').then((m) => m.financeRoutes),
    canActivate: [authGuard, financeQueueGuard],
}
